/*
 * @Author: your name
 * @Date: 2020-07-02 19:26:20
 * @LastEditTime: 2021-01-03 20:00:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-workspace/packages/x-project-app/src/vendor/form-schema-config/widget.config.js
 */
const WidgetConfig = [
  {
    groupType: 'COMMON_COMPONENT',
    groupName: '常用组件',
    groupWidgetList: [
      // 支持 ['string'] 或 [{ 'componentType': 'string' }]
      'FORM_TEXT_INPUT',
      'FORM_TEXTAREA_INPUT',
      'FORM_NUMBER_INPUT',
      'FORM_DATEPICK_INPUT',
      'FORM_PEOPLE_SELECT',
      'FORM_DEPARTMENT_SELECT',
      'FORM_PHONE_INPUT',
      'FORM_EMAIL_INPUT',
      'FORM_IDCARD_INPUT',
      'FORM_RADIO_INPUT',
      'FORM_CHECKBOX_INPUT',
      'FORM_SELECT_INPUT',
      'FORM_MONEY_INPUT',
      'FORM_FILE_UPLOAD',
      'FORM_RICH_TEXT',
      'FORM_WIDGET_AREA',
      'FORM_WIDGET_LOCATION',
      'FORM_HYPERLINK_INPUT'
    ]
  },
  {
    groupType: 'ADVANCE_COMPONENT',
    groupName: '高级组件',
    groupWidgetList: [
      // 支持 ['string'] 或 [{ 'componentType': 'string' }]
      'FORM_DOCUMENT_NUMBER',
      'FORM_WIDGET_CALC',
      'FORM_DATA_SELECTOR',
      'FORM_DATA_ASSIGNMENT',
      'FORM_WIDGET_TABLE',
      'FORM_ASSOCIATION',
      'FORM_DATA_STATISTICS',
      'FORM_OCR_IDENTIFY',
      'FORM_OTHER_TABLE_FIELD'
    ]
  },
  {
    groupType: 'LAYOUT_COMPONENT',
    groupName: '页面布局组件',
    groupWidgetList: [
      // 支持 ['string'] 或 [{ 'componentType': 'string' }]
      'FORM_STATIC_TEXT',
      'FORM_STATIC_IMG',
      'FORM_WIDGET_SPLIT',
      'FORM_WIDGET_SPACE'
    ]
  }
]

export default WidgetConfig
